<template>
  <b-container>
  <!-- <h1 class="text-center pt-4 pb-4">Ajout d'un statut</h1>-->
  <b-form @submit="onSubmit">

    <p v-html="$t('info.removeConfirmedUserBuilding', [formatName(), building.NOMDIV])"></p>

    <b-button class="mt-4 text-center" type="submit" variant="danger" :disabled="disabled">{{ $t("action.confirmed") }}</b-button>

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>

    <div v-if="activesessions" class="mt-2">
      <b-alert show variant="warning">
        <p>{{ $t("info.activesessions") }}</p>
        <b-button class="mt-2" variant="link" @click="openmodal('transfertAllSession')">{{ $t("action.transfertAllSession") }}</b-button>         
      </b-alert>
    </div>

    <div v-if="success" class="pt-4">
      <b-alert show variant="success">
        <p>{{ $t("info.successgeneric") }}</p>
      </b-alert>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>

  </b-form>

 <b-modal id="transfertAllSession" :title="$t('title.confirmation')" hide-footer>
       <b-row class="mt-2">
        <b-col sm="6" class="mt-4">
          <b-form-select v-model.trim="$v.user.$model" :options="users"></b-form-select>
          <div class="text-danger" v-if="!$v.user.required && $v.user.$dirty">{{ $t("info.required") }}</div>
        </b-col>
      </b-row>

      <b-button class="mt-4" variant="danger" @click="transfertAllSession()">{{ $t("action.confirmed") }}</b-button>
    </b-modal>
</b-container>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';

import { globalF } from '../Helpers';

export default {
mixins: [globalF],
props: ['currentUser',  'building', "modalid"],
data: () => ({
  disabled: false,
  success: false,
  error: "",
  spinner: false,
  activesessions: false,
  user: null
}),
validations() {
    return {
      user: {required}
    }
},
computed: {
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  },
  users: function () {
    let list = this.$store.getters.getUserList;
    let userToEdit = this.currentUser;
    let array = [];

    if (list && userToEdit) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].Id !== userToEdit.Id) {
          let options = {};
          options.value = list[i];
          options.text = list[i].fname.concat(" "+list[i].lname);
          array.push(options);
        } 
      }
    }

    array.unshift({value: null, text: this.$t('action.choose')});
      
    return array;
  }
 },
methods:{
  formatName() {
      return this.currentUser.fname.concat(" ", this.currentUser.lname);
    },
  openmodal: function (id) {
      this.chooseUser = true;
      this.$bvModal.show(id);      
    },
transfertAllSession: function () {
    this.error = "";
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.spinner = true;

      let promise = this.validateToken();  
      promise.then(() => {
        axios.post(this.url, {request: "transfertActiveSession", NewUser: this.user.Id, IdUser: this.currentUser.Id, IdBuilding: this.building.Id,
      NOCIE: this.building.NOCIE, NODIV: this.building.NODIV}, { headers: {'Content-Type': 'application/json'}})
          .then(res => {
          if (res.data === 0) {
                this.success = true;
                this.$store.commit('setReloadValue', true);
                this.$bvModal.hide("transfertAllSession");
                this.$bvModal.hide(this.modalid);               
              }
              this.spinner = false;
            })
            .catch(() => {
              this.spinner = false;
              this.$bvModal.hide("transfertAllSession");
              this.error = this.$t('info.errorgeneric');
          })
      });

    }
  },
  onSubmit(evt) {
      evt.preventDefault();
      
        this.success = false;
        this.error = "";
        this.disabled = true;
        this.spinner = true;

        let promise = this.validateToken();  
        promise.then(() => {
          axios.post(this.url, {request: "removeUserForBuilding", IdUser: this.currentUser.Id, IdBuilding: this.building.Id, NOCIE: this.building.NOCIE, NODIV: this.building.NODIV }, { headers: {'Content-Type': 'application/json'}})
          .then(res => {
          if (res.data === 0) {
                this.$store.commit('setReloadValue', true);
                this.$bvModal.hide(this.modalid);               
              }
              if (res.data === "activesessions") {
                this.activesessions = true;
              }
              this.spinner = false;
            })
            .catch(() => {
              this.spinner = false;
              this.error = this.$t('info.errorgeneric');
          })
        });
    },
    
  }
}
</script>
